import React from 'react';
import { GetServerSideProps } from 'next';
import axios from 'axios';
import PageWrapper from '../components/PageWrapper';
import SEO from '../components/SEO';
import WhoWeAre from '../components/AboutUs/WhoWeAre';
import MissionVision from '../components/AboutUs/MissionVision';
import WhatWeDo from '../components/AboutUs/WhatWeDo';
import WhyEpen from '../components/AboutUs/WhyEpen';
import OurValues from '../components/AboutUs/OurValues';
import WorkWithUs from '../components/AboutUs/WorkWithUs';

interface AboutUsPageProps {
  aboutData: any[];
}

const AboutUsPage = ({ aboutData }: AboutUsPageProps) => {
  return (
    <>
      <SEO
        title="About Us"
        description="Learn about EPEN Ltd., a technology-driven company focused on building professional tools and frameworks for video development and high-performance software systems."
        type="website"
      />
      <PageWrapper
        dateText="About us"
        titleText="About the company"
        introText="Learn more about the company and the team behind it."
        title="About Us"
        aboutData={aboutData}
        contentContainerClass=""
      >
        <WhoWeAre />
        <MissionVision />
        <WhatWeDo />
        <WhyEpen />
        <OurValues />
        <WorkWithUs />
      </PageWrapper>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  let aboutData = [];

  try {
    const aboutResponse = await axios.get(
      `${process.env.NEXT_PUBLIC_REACT_APP_BASE_URL1}/about-us`
    );
    aboutData = aboutResponse.data.data || [];

    aboutData = aboutData.map((item: any) => {
      let address = '';
      if (item.address) {
        if (typeof item.address === 'string' && item.address.trim()) {
          address = item.address.trim();
        } else if (item.address) {
          address = String(item.address).trim();
        }
      }
      return {
        address: address || '',
        phone: String(item.phone || ''),
        email: String(item.email || ''),
      };
    });

    if (!aboutData || aboutData.length === 0) {
      aboutData = [];
    }
  } catch (err) {
    console.error('❌ [About Us Page] Error fetching about data:', err);
    aboutData = [];
  }

  return {
    props: {
      aboutData: aboutData,
    },
  };
};

export default AboutUsPage;

